import React, {useState, useContext} from 'react'

import { NavigationContext } from './NavigationController'
import ImageUploader from './ImageUploader'

import { withStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'

const styles = theme => ({
  input: {
    display: 'none',
  },
  boxAttachment: {
    position: 'relative'
  },
  iconFile: {
    width: '100%', 
    height: '100%'
  },
  fileNameText: {
    wordWrap:'break-word', 
    textAlign:'center'
  },
  extensionName: {
    position:'absolute', 
    left:'50%', 
    top:'50%', 
    transform: 'translate(-50%, -50%)', 
    color: 'white'
  },
  boxDelete: {
    cursor:'pointer',
    position:'absolute', 
    top:'4px', 
    right:'4px', 
    padding:'4px', 
    display:'flex', 
    justifyContent:'center', 
    alignItems:'center'
  },
  iconDelete: {
    fontSize: 20
  },
  boxInsert: {
    cursor:'pointer', 
    padding: 32, 
    border: '1px dashed black', 
    top:0, 
    width:'100%', 
    height:'100%', 
    display:'flex', 
    justifyContent:'center', 
    alignItems:'center'
  },
  iconAdd: {
    fontSize:'2.5rem'
  }
});

const AttachmentListView = ({ theme, classes, edit, name, initialData, formData, onFormDataChange, uploadMediaContent, ...props }) => {

  const navigationContext = useContext(NavigationContext)
  const attachmentsData = formData[name] || initialData[name] || []

  const [showUploader, setShowUploader] = useState(false)

  const addNewImages = (name, files) => {  
  
    let dataAttachments = {
      title: '',
      media: files,
      name: name
    }
  
    let resultUpload = uploadMediaContent(dataAttachments); 
    let resultData = new Promise((resolve, reject) => {
        resolve(resultUpload)})
      return resultData
  }

  const onSaveUpload = (files) => {
    if (files) {
      let newAttachments = [...attachmentsData]
      let resultAttachments = newAttachments.concat(files)
      onFormDataChange({
          [name]: resultAttachments
      })
      setShowUploader(false)
    } else
      alert('File required.')
  }

  return (
    <Box display='flex' flexDirection='row' width='100%'>
      { attachmentsData && attachmentsData.map((item,index) =>
        <Box 
          width='10%' 
          height='100%' 
          mr={1} 
          className={classes.boxAttachment} 
          onClick={() => edit ? null : window.open(item.attachment_url)}
          >
          <InsertDriveFileIcon className={classes.iconFile}/>
          <Typography variant='body2' className={classes.fileNameText}>
            {item.file_name}
          </Typography>
          <Typography variant='body2' className={classes.extensionName}>
            {item.file_name ? item.file_name.split('.').pop().toUpperCase() : ''}
          </Typography>
          { edit &&
            <Box 
              onClick={() => {
                let newAttachments = [...attachmentsData]
                newAttachments.splice(index, 1)
                onFormDataChange({
                  [name]: newAttachments
                })
              }}
              className={classes.boxDelete}
              >
                <DeleteIcon color='secondary' className={classes.iconDelete} />
            </Box>
          }
        </Box>
      )}

      { edit &&
        <Box width='auto' height='100%' mr={1} onClick={() => setShowUploader(true)}>  
          <Box className={classes.boxInsert}>
              <AddIcon color='primary' className={classes.iconAdd}/>
          </Box>
        </Box>
      }

      { showUploader &&
        <ImageUploader 
          fieldName={name} performUpload={addNewImages} accept="*" 
          onClose={ () => { setShowUploader(false); } } recommendedImageSize={'< 500kb'}
          onSave={ onSaveUpload }
          />
      }
    </Box>
  )
}

export default withStyles(styles, { withTheme: true })(AttachmentListView)